export function flagPathPrefixes(flags: string[], flagPrefix: string): string[] {
  return flags
    .filter(flag => flag.startsWith(flagPrefix))
    .map(flag => flag.slice(flagPrefix.length).trim())
    .filter(prefix => prefix.startsWith('/'))
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function wildcardMatcher(prefix: string): RegExp {
  const pattern = prefix
    .split('/')
    .map(segment => segment === '*' ? '[^/]+' : escapeRegExp(segment))
    .join('/')
  return new RegExp(`^${pattern}(?:/|$)`)
}

export function pathMatchesPrefix(path: string, prefixes: string[]): boolean {
  const bare = path.replace(/^\/project\/[^/]+/, '') || '/'
  return prefixes.some((prefix) => {
    const clean = prefix.length > 1 ? prefix.replace(/\/+$/, '') : prefix
    if (clean === '/') {
      return true
    }
    if (clean.includes('*')) {
      const matcher = wildcardMatcher(clean)
      return [path, bare].some(candidate => matcher.test(candidate))
    }
    return [path, bare].some(candidate => candidate === clean || candidate.startsWith(`${clean}/`))
  })
}
